module.exports = __webpack_public_path__ + "img/balance_bg.13d81e45.png";